import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from 'vue';

  
  import { defineComponent } from 'vue';

  const __default__ = defineComponent({
    name: 'Button',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    focus: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (event: 'click'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { focus: boolean }

  
  const { focus } = toRefs(props);

  

return { __sfc: true,props, focus, emit }
}

})